import React from 'react';
import {BUTTON_TYPES} from '../../../utils/Constants';
import {useTheme} from '../../../theme';
import {tID} from '../../../utils/TestIdHelper';
import BottomExpandableDrawer from '../BottomExpandableDrawer';
import {CloseIcon} from '../../../utils/SvgIcons';

const FaceIdFailed = ({visible, onClose, onTryAgain}) => {
  const {colors} = useTheme();
  return (
    <BottomExpandableDrawer
      testID={tID('FaceIdFailed-Modal-BottomExpandableDrawer')}
      visible={visible}
      showRipple
      rippleColor={colors.dangerMuted}
      rippleIcon={<CloseIcon />}
      title="Face ID Failed"
      subtitle="Sorry, Face ID couldn't recognize you."
      onClose={onClose}
      buttons={[
        {
          title: 'Cancel',
          buttonType: BUTTON_TYPES.Bordered,
          onPress: onClose,
        },
        {
          title: 'Try Again',
          buttonType: BUTTON_TYPES.Filled,
          onPress: onTryAgain,
        },
      ]}
    />
  );
};

export default FaceIdFailed;
